/**
 * Sidebar entry (the `label` of composables/menu.js, plus the global entries of
 * Components/Sidebar/AppSidebar.vue) -> illustration of the AirLST Design System
 * (airlst2027 www/assets/icons/illu, synced to public/images/ds-illustrations by `yarn ds:sync`).
 * Used only in the design-system look; an entry without an illustration keeps its icon.
 */
export const SIDEBAR_ILLUSTRATIONS = {
  events: 'evt-event',
  organisation: 'globe',
  contacts: 'mod-crm',
  dam: 'gallery',
  cockpit: 'mod-reporting',
  custom_reports: 'poll',
  guests: 'people',
  content: 'template',
  landingpage: 'mod-landing',
  airstage: 'mod-ki',
  forms: 'mod-anmeldung',
  custom_landingpage: 'mod-custom',
  event_app: 'phone',
  scan_my_lead: 'qr',
  tickets_and_addons: 'mod-tickets',
  payments: 'mod-payment',
  email: 'mod-email',
  sms: 'mod-anfrage',
  event_documents: 'mod-docs',
  seating: 'mod-seats',
  settings: 'setup',
  marketplace: 'marketplace',
  planner: 'mod-reporting',
}

/**
 * @param {string} key
 * @returns {string|null} asset path of the illustration, or null
 */
export const sidebarIllustration = (key) =>
  SIDEBAR_ILLUSTRATIONS[key]
    ? `images/ds-illustrations/${SIDEBAR_ILLUSTRATIONS[key]}.svg`
    : null
